import React, { useEffect, useState } from 'react'
import './App.css'
import { Link, Redirect, useHistory } from 'react-router-dom'
import Axios from 'axios'
import { IoIosArrowBack } from 'react-icons/io'
import ClipLoader from 'react-spinners/ClipLoader'
import Header2 from './components/Header2'
import Header3 from './components/Header3'
import Header5 from './components/Header5'
import { BiMenu } from 'react-icons/bi'
import SideNav from './layouts/SideNav'
import Header from './layouts/Header'
import SideNavCust from './layouts/SideNavCust'
import SideNavAff from './layouts/SideNavAff'
import { API_URL } from './config'

const FeedbackPage = () => {
  const history = useHistory()
  const [successError, setSuccessError] = useState()
  const [errorDisplay, setErrorDisplay] = useState()
  const [error, setError] = useState()
  const [feedback, setFeedback] = useState()
  const [loading, setLoading] = useState(false)
  const [subBtn, setSubtn] = useState('btn-disabled')
  const [disabled, setDisabled] = useState(true)
  const [count, setCount] = useState(0)
  const [context, setContext] = useState('')

  const isMobile = window.innerWidth <= 768
  const [isMob, setIsMob] = useState()
  const [collapsed, setCollapsed] = useState(isMobile)

  const updateIsMobile = () => {
    const mobile = window.innerWidth <= 768
    setIsMob(mobile)
    setCollapsed((prev) => (mobile ? true : prev))
  }

  useEffect(() => {
    let customerid = ''
    let customername = ''

    if (localStorage.getItem('customername') !== null) {
      customername = localStorage.getItem('customername') + ' - Customer'
      customerid = localStorage.getItem('customerid')
    } else if (localStorage.getItem('businessname') !== null) {
      customername = localStorage.getItem('businessname') + ' - Organiser'
      customerid = localStorage.getItem('businessid')
    } else if (localStorage.getItem('partnername') !== null) {
      customername = localStorage.getItem('partnername') + ' - Affiliate'
      customerid = localStorage.getItem('partnerid')
    }

    document.title = customername + ' - Feedback'

    updateIsMobile()
    window.addEventListener('resize', updateIsMobile)

    return () => {
      // this runs on unmount
      window.removeEventListener('resize', updateIsMobile)
    }

    // Optionally store or use customerid for future logic
    // e.g., setCustomerId(customerid) if using state
  }, [count]) // empty dependency array = run once on mount

  const HandleFeedback = (event) => {
    const feedbackText = event.target.value
    if (feedbackText.length > 0) {
      setDisabled(false)
      setSubtn('save-btn')
    } else {
      setDisabled(true)
      setSubtn('btn-disabled')
    }
    setFeedback(event.target.value)
    setErrorDisplay('none')
  }

  const update = () => {
    let customerid = ''
    setLoading(true)
    setSubtn('btn-disabled')
    setDisabled(true)

    const baseURL = `${API_URL}/apps/kscanner/webservices.php`

    const data = new FormData()
    data.append('feedback', feedback ?? '')
    data.append('context', context ?? '')
    data.append('query', 'FEEDBACK')
    Axios({
      method: 'POST',
      url: baseURL,
      data: data,
      withCredentials: true,
    })
      .then((response) => {
        let addClass = ''
        if (response.data.status === 'failed') {
          addClass = 'error-login'
        } else {
          addClass = 'success-login'
        }
        setError(response.data.message)
        setErrorDisplay('block')
        setSuccessError(addClass)
        setLoading(false)
        setSubtn('btn-disabled')
        setDisabled(true)
        setFeedback('')
      })
      .catch(function (error) {
        console.log(error)
        setLoading(false)
        setSubtn('save-btn')
        setDisabled(false)
        setFeedback('')
      })

    setTimeout(() => {
      setErrorDisplay('none')
    }, 5000)
  }

  let { accountname, dashboard } = ''
  if (localStorage.getItem('customername') === null) {
    if (localStorage.getItem('businessname') === null) {
      if (localStorage.getItem('partnername') === null) {
        return <Redirect to="/login" />
      } else {
        accountname = localStorage.getItem('partnername')
        dashboard = 'in'
      }
    } else {
      accountname = localStorage.getItem('businessname')
      dashboard = 'dashboard'
    }
  } else {
    accountname = localStorage.getItem('customername')
    dashboard = 'customerdashboard'
  }
  const customername = accountname

  const handleToggle = () => {
    setCollapsed((prev) => !prev)
  }

  const accounttype = localStorage.getItem('accounttype')
  return (
    <div className="view">
      <Header />
      {accounttype === 'customer' ? (
        <>
          <SideNavCust collapsed={collapsed} onToggle={handleToggle} />
        </>
      ) : accounttype === 'business' ? (
        <>
          <SideNav collapsed={collapsed} onToggle={handleToggle} />
        </>
      ) : (
        <SideNavAff collapsed={collapsed} onToggle={handleToggle} />
      )}

      <div
        className="container"
        style={{
          marginTop: 40,
          marginLeft: isMob ? '0px' : collapsed ? 'auto' : 'auto',
        }}
      >
        {/* ✅ Mobile overlay when sidebar is open */}
        {isMobile && !collapsed && <div className="mobile-overlay active" onClick={handleToggle} />}

        {isMob && collapsed && (
          <label className="mobile-toggle" onClick={handleToggle}>
            <BiMenu size={25} />
          </label>
        )}
        <div className="row justify-content-center just-container-insid">
          <div className="col-lg-7 pl-0 pr-0">
            <div className=" BoxDashboardContainer mt-5 mb-4 mrgin-search pl-0 pr-0">
              <div className="row align-self-center justify-content-center">
                <div className="item-list p-0">
                  <div className="col-12 pl-0">
                    <button type="button" onClick={() => history.goBack()} className="link-btn">
                      <IoIosArrowBack size={25} />
                      Back &nbsp;
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className=" BoxDashboardContainer pl-0 pr-0 mb-5">
              <div className="row align-self-center justify-content-center">
                <div className="item-list p-0">
                  <div className="col-lg-12 pl-0">
                    <span className="pl-0 pr-0">
                      Your Experience Matters — Help Shape Karamale
                      <br />
                      <span className="note-line font-normal">
                        We're building South Africa's most trusted event tech platform. Share your
                        feedback on Karamale, the KScanner, and your ticketing journey — every
                        insight helps us serve organisers and attendees better.
                      </span>
                    </span>
                  </div>
                </div>

                <div className="h-divider w-100"></div>
              </div>
              <div className="col-lg-12 pb-3">
                <label className="text-bold">Role</label>
                <br />
                <select className="form-control" onChange={(e) => setContext(e.target.value)}>
                  <option value="" disabled selected>
                    Select your role
                  </option>
                  <option value="organiser" className={accounttype !== 'business' ? 'd-none' : ''}>
                    Event Organiser
                  </option>
                  <option
                    value={'scanner_operator'}
                    className={accounttype !== 'business' ? 'd-none' : ''}
                  >
                    Kscanner Operator
                  </option>
                  <option
                    value="ticket_buyer"
                    className={accounttype !== 'customer' ? 'd-none' : ''}
                  >
                    Ticket Buyer / Attendee
                  </option>
                  <option value="partner" className={accounttype !== 'partner' ? 'd-none' : ''}>
                    Partner / Affiliate
                  </option>
                </select>
              </div>
              <div className="col-lg-12 pb-3">
                <label className="text-bold">Share Your Feedback or Testimonial</label>
                <br />
                <textarea
                  value={feedback}
                  placeholder="Type here..."
                  onChange={HandleFeedback}
                  className="edit-input form-control"
                  rows={10}
                />
              </div>

              <div className="col-12 text-right">
                <label className="back-arrow mb-0">
                  <button
                    disabled={disabled}
                    className={subBtn + ' text-bold'}
                    onClick={() => update()}
                  >
                    {!loading ? (
                      'Submit'
                    ) : (
                      <ClipLoader
                        color={'#333'}
                        loading={true}
                        // css={override}
                        size={20}
                      />
                    )}
                  </button>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={successError} style={{ display: errorDisplay, textAlign: 'center' }}>
        {error}
      </div>
      {/* <Footer /> */}
    </div>
  )
}

export default FeedbackPage
